import React from 'react';
export function Footer() {
  return <footer className="py-8 bg-navy-950 border-t border-white/5 text-center px-4" data-id="element-70">
      <p className="text-slate-500 text-sm" data-id="element-71">
        © {new Date().getFullYear()} Secretos de Promoción. Todos los derechos
        reservados.
      </p>
    </footer>;
}